import apiService from '@/api/apiService';
import { handleHttpError } from '@/api/errorHandler';

/**
 * 建立資產負債表版本
 * @param {Object} payload
 * @param {number} payload.user_id
 * @param {number} payload.user_detail_id
 * @param {string} payload.external_name
 * @param {string} payload.internal_name
 * @param {number} payload.source
 * @param {boolean} payload.is_visible_user
 * @returns {Promise<Object>} API 回應
 */
export const createVersion = async (payload) => {
    try {
        const url = '/api/admin/balance/version';
        return await apiService.POST(url, payload);
    } catch (error) {
        throw handleHttpError(error, url, 'POST');
    }
};
